import React from "react"
import { Small } from "../ui/typography"
import { Button } from "../ui/button"
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react"
import { cn } from "@/lib/utils"

type TablePaginationProps = {
	currentPage: number
	pageCount: number
	onFirstPage: () => void
	onPreviousPage: () => void
	onNextPage: () => void
	onLastPage: () => void
	canPreviousPage: boolean
	canNextPage: boolean
	className?: string
}

export function TablePagination({
	currentPage,
	pageCount,
	onFirstPage,
	onPreviousPage,
	onNextPage,
	onLastPage,
	canPreviousPage,
	canNextPage,
	className,
}: TablePaginationProps) {
	return (
		<div className={cn("flex justify-center items-center gap-8", className)}>
			<Small>
				Page {currentPage} of {pageCount}
			</Small>
			<div className="flex items-center gap-2">
				<Button
					variant="outline"
					size="icon"
					onClick={onFirstPage}
					disabled={!canPreviousPage}
				>
					<ChevronsLeft className="h-4 w-4" />
				</Button>
				<Button
					variant="outline"
					size="icon"
					onClick={onPreviousPage}
					disabled={!canPreviousPage}
				>
					<ChevronLeft className="h-4 w-4" />
				</Button>
				<Button
					variant="outline"
					size="icon"
					onClick={onNextPage}
					disabled={!canNextPage}
				>
					<ChevronRight className="h-4 w-4" />
				</Button>
				<Button
					variant="outline"
					size="icon"
					onClick={onLastPage}
					disabled={!canNextPage}
				>
					<ChevronsRight className="h-4 w-4" />
				</Button>
			</div>
		</div>
	)
}
